import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import PropTypes from 'prop-types'

import classNames from './ProfilePictureInput.css'

class ProfilePictureInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileUploaded: null,
    }
    this.onDropBanner = this.onDropBanner.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fileUploaded !== this.state.fileUploaded) {
      this.setState({
        fileUploaded: nextProps.fileUploaded,
      })
    }
  }

  onDropBanner(files) {
    this.setState({ fileUploaded: files[0] })
    this.uploadPicture(files[0])
  }

  uploadPicture(file) {
    let errorMessage = ''
    if (file.type === 'image/png' || file.type === 'image/jpeg') {
      if (file.size <= 500000) {
        return this.setState({
          errorTextBannerMessage: '',
          bannerType: file.type,
        }, () => this.props.uploadPicture({ file, message: '' }))
      }
      errorMessage = 'Arquivo muito grande. Selecione um arquivo com tamanho inferior a 500Kb.'
    } else {
      errorMessage = 'Tipo de arquivo não permitido. Selecione um arquivo do tipo imagem (PNG ou JPEG).'
    }

    if (errorMessage) {
      this.props.onError(errorMessage)
    }

    return this.setState({
      errorTextBannerMessage: errorMessage,
      bannerType: file.type,
    }, () => this.props.uploadPicture({ file: null, message: errorMessage }))
  }

  render() {
    const pictureToShown = !this.state.fileUploaded
      ? (
        <img
          style={{
            alignSelf: 'center',
            marginTop: this.props.iconMarginTop,
          }}
          height={this.props.iconHeight}
          width={this.props.iconWidth}
          src={`/assets/icons/${this.props.icon}.svg`}
          alt="Default"
        />
      )
      : (
        <img
          height={this.props.height}
          width={this.props.width}
          src={this.state.fileUploaded.preview}
          alt="Uploaded"
        />
      )
    return (
      <div style={{ textAlign: 'center', width: this.props.width + 6, cursor: 'pointer' }}>
        <div style={{ position: 'relative', backgroundColor: 'transparent', height: this.props.height + 12 }}>
          <Dropzone
            className={classNames.dropzone}
            onDrop={this.onDropBanner}
            multiple={false}
            style={{
              width: this.props.width,
              height: this.props.height,
              backgroundColor: 'white',
            }}
          >
            {pictureToShown}
            {
              !this.state.fileUploaded &&
              <img
                alt="New upload"
                src="/assets/icons/upload.svg"
                className={classNames.iconStyle}
              />
            }
          </Dropzone>
        </div>
        {
          !this.state.fileUploaded &&
          <span className={classNames.descriptionStyle}>{this.props.textValue}</span>
        }
      </div>
    )
  }
}


ProfilePictureInput.defaultProps = {
  height: 120,
  width: 120,
  textValue: 'Insira a foto',
  icon: 'truck',
  iconWidth: 60,
  iconHeight: 55,
  iconMarginTop: 30,
  onError: () => {},
  uploadPicture: () => {},
}

ProfilePictureInput.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  textValue: PropTypes.string,
  uploadPicture: PropTypes.func,
  icon: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  iconMarginTop: PropTypes.number,
  onError: PropTypes.func,
}

export default ProfilePictureInput
